<template>
	<div class="ao-chips d-flex flex-wrap">

		<ao-chip
			v-for="(item, idx) in items"
			:key="`ao-chip-${idx}`"
			:item="item"
			:itemTitle="itemTitle"
			:itemValue="itemValue"
			:size="size"
			:color="color"
		/>

	</div>
</template>

<script setup>
defineProps({

	items: {
		type: Array,
		default: () => ([]),
	},

	itemTitle: {
		type: String,
	},

	itemValue: {
		type: String,
	},

	color: {
		type: String,
	},

	size: {
		type: [String, Number],
		default: 'small',
	},

})
</script>
